import { StorePickupFieldsFragment } from '../../graphql';

export const isStoreConnected = ({
	terminals,
	driveThruPickup,
	inStorePickup,
	parkingLotPickup
}: StorePickupFieldsFragment): boolean => {
	const driveThruConnected = terminals.some(
		terminal => terminal.status === 'CONNECTED' && terminal.termId === 3
	);

	const counterConnected = terminals.some(
		terminal => terminal.status === 'CONNECTED' && terminal.termId === 2
	);

	const driveThruPickupAvailable = driveThruPickup && driveThruConnected;
	const inStorePickupAvailable = inStorePickup && counterConnected;
	const parkingLotPickupAvailable = parkingLotPickup && counterConnected;

	return (
		driveThruPickupAvailable ||
		inStorePickupAvailable ||
		parkingLotPickupAvailable
	);
};
